import arriereBackoffice from '@avantstay/arriere-clients/dist/arriereBackoffice'

import { getLocalStorageItem } from '@utils/localStorage'

import { selectBackofficeRouter } from './backofficeRouterSelection'

export const backofficeRouter = selectBackofficeRouter({
  mode: import.meta.env.MODE,
  hiveUrl: import.meta.env.VITE_ARRIERE_BACKOFFICE_HIVE_URL,
  optIn: getLocalStorageItem('voyage:hive-router'),
})

if (backofficeRouter.url) arriereBackoffice.setUrl(backofficeRouter.url)
